import React from "react";
import { useEffect, useState } from "react";
import BlockUi from "react-block-ui";
import { loaderMsg, loadertype } from "../../constants";
import Loader from "react-loaders";
import { getPaymntGistory } from "../../util/APIUtils";
import AddIncomeBody from "./AddIncomeBody";

export default function AddIncome() {
  const [values, setValues] = useState({
    frmDate: new Date().toISOString().substring(0, 10),
    toDate: new Date().toISOString().substring(0, 10),
  });
  const [trans, setTrans] = useState([]);
  const [block, setBlock] = useState(false);

  useEffect(() => {
    loadReqData();
  }, []);

  const loadReqData = () => {
    setBlock(true);
    getPaymntGistory(values).then((response) => {
      setTrans(response);
      setBlock(false);
    });
  };

  return (
    <BlockUi
      tag="div"
      blocking={block}
      loader={<Loader active type={loadertype} color="#8dc63f" />}
      message={loaderMsg}
    >
      <div className="animated fadeIn">
        <AddIncomeBody data={trans} />
      </div>
    </BlockUi>
  );
}



// WEBPACK FOOTER //
// ./src/components/CustomComponents/AddIncome.js